import controller from './paycell-info-link.controller';

export default {
  controller,
  template: require('./paycell-info-link.html')
};



// WEBPACK FOOTER //
// src/app/components/paycell-info-link/paycell-info-link.component.ts